import { css } from "../helpers/webComponents";
import "./puzzles/BombDefusePuzzle";

const styles: string = css`
    :host {
        position: absolute;
        inset: 0;
        z-index: 10;
        background: rgba(0, 0, 0, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export interface IPuzzleComponent extends HTMLElement {
    /**
     * Renders the puzzle and replaces the current element content with the new puzzle content.
     */
    start(): void;
}

/**
 * Container for the puzzles that takes care of the rendering of the correct puzzle based on the room alias and background overlay
 */
export class PuzzleComponent extends HTMLElement {
    private _room?: string;

    public set room(alias: string) {
        this._room = alias;
        this.render();
    }

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        if (this._room) {
            this.render();
        }
    }

    private render(): void {
        if (!this.shadowRoot || !this._room) {
            return;
        }

        // for example, if the room alias is "10", the puzzle component will be "puzzle-10"
        const element: string = `puzzle-${this._room}`;

        const puzzle: IPuzzleComponent = document.createElement(element) as IPuzzleComponent;

        const style: HTMLStyleElement = document.createElement("style");
        style.textContent = styles;

        // replace the current content with the new puzzle content
        this.shadowRoot.replaceChildren(style, puzzle);
        puzzle.start();
    }
}

customElements.define("puzzle-container", PuzzleComponent);
